import { Component, OnInit } from '@angular/core';
import { AbstractCalculatorComponentDirective } from '../abstract-calculator-component.directive';
import { FormControl, Validators } from '@angular/forms';
import { inOutAnimation } from '../../../../animations';
import { ETypeCalculation } from '../../../../models/analysis/solar-calculator-request';
import { UserRole } from '../../../../models/user/user-role.enum';

@Component({
  selector: 'psc-calculator-plant-data',
  templateUrl: './calculator-plant-data.component.html',
  animations: [
    inOutAnimation({ enterDelay: 0.5 }),
  ],
})
export class CalculatorPlantDataComponent extends AbstractCalculatorComponentDirective implements OnInit {
  showInputs: boolean;

  ngOnInit() {
    this.subs.add(
      this.manager.type_calculation.subscribe((value: ETypeCalculation) => {
        if (this.authService.userHasRole(UserRole.ROLE_PERSONAL) &&
          (value === ETypeCalculation.BA_FE_FEED_IN_CALC ||
            value === ETypeCalculation.BA_RS_FEED_IN_CALC ||
            value === ETypeCalculation.HR_FEED_IN_CALC ||
            value === ETypeCalculation.NO_FEED_IN_ENERGY)
        ) {
          this.showInputs = true;
          this.formGroup.addControl('project_name', new FormControl('', Validators.required));
          this.formGroup.addControl('address', new FormControl('', Validators.required));

          this.manager.location.subscribe((value) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: value },
              (results, status) => {
                if (status == google.maps.GeocoderStatus.OK && results && results.length > 0) {
                  this.formGroup.controls['address']?.setValue(results[0].formatted_address);
                }
              });
          });
        } else {
          this.showInputs = false;
          if (this.formGroup.controls['project_name']) {
            this.formGroup.removeControl('project_name');
          }
          if (this.formGroup.controls['address']) {
            this.formGroup.removeControl('address');
          }
        }
        this.formGroup.updateValueAndValidity();
      })
    );
  }
}
